// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billStatusEntity from './entities/bill-status.json';
import billStatusMenu from '../pages/bill-status/menu.json';
import billStatusFullForm from '../pages/bill-status/forms/full.json';
import billStatusContextForm from '../pages/bill-status/forms/context.json';
import billStatusMiniForm from '../pages/bill-status/forms/mini.json';
import billStatusLookupForm from '../pages/bill-status/forms/lookup.json';
import billStatusTableView from '../pages/bill-status/views/table.json';
import billStatusDashboardView from '../pages/bill-status/views/dashboard.json';

/** Тип запису «Етап законопроєкту» зі сторінками пакета: меню, форми та подання з pages/bill-status/. */
export const billStatusDefinition: IRecordTypeDefinition = {
  ...billStatusEntity,
  views: assembleViewSet({
      table: billStatusTableView,
      dashboard: billStatusDashboardView,
  }),
  form: billStatusFullForm,
  forms: { full: billStatusFullForm, context: billStatusContextForm, mini: billStatusMiniForm, lookup: billStatusLookupForm },
  menu: billStatusMenu,
} as IRecordTypeDefinition;
